// Base URL for the new backend API
export const API_BASE_URL = 'https://api2.montelcompany.me/api/lk';
